import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import assignmentSubmissionApis from "../../api/assignmentSubmissionApis";
import { AssignmentSubmission } from "../../types/assignmentSubmission";

interface SubmissionState {
  submissions: AssignmentSubmission[];
  loading: boolean;
}

const initialState: SubmissionState = {
  submissions: [],
  loading: false,
};

export const fetchSubmissions = createAsyncThunk(
  "submission/fetchSubmissions",
  async (assignmentId: string, { rejectWithValue }) => {
    try {
      return await assignmentSubmissionApis.getSubmissionsByAssignmentId(
        assignmentId,
      );
    } catch {
      return rejectWithValue("Failed to fetch submissions");
    }
  },
);

const submissionSlice = createSlice({
  name: "submission",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSubmissions.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSubmissions.fulfilled, (state, action) => {
        state.loading = false;
        state.submissions = action.payload.data || [];
      })
      .addCase(fetchSubmissions.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const submissionReducer = submissionSlice.reducer;
